import { first, last } from 'lodash';

import withOptions from 'utils/functions/withOptions.util';
import asObject from 'utils/objects/asObject.util';
import parseJson from 'utils/parsers/parseJson';

const elementById = window.document.getElementById; // eslint-disable-line prefer-destructuring
const elementFromPoint = window.document.elementFromPoint; // eslint-disable-line prefer-destructuring
const elementsByClassName = window.document.getElementsByClassName; // eslint-disable-line prefer-destructuring
const querySelectorAll = window.document.querySelectorAll; // eslint-disable-line prefer-destructuring

const determineDropLocation = withOptions(({ touchX, touchY, mouseX, mouseY, rangeByHours, stylistId }) => {
  const elColumnHead = elementById(`column-header-${stylistId}`);
  const elSchedulerHead = first(elementsByClassName('scheduler-header'));

  const { offsetHeight: cHeight, offsetTop: cTop } = asObject(elColumnHead);
  const { offsetHeight: sHeight } = asObject(elSchedulerHead);

  if (touchX) {
    const elementTouchIsOver = elementFromPoint(touchX, touchY);
    if (elementTouchIsOver) {
      if (elementTouchIsOver.id) return parseJson(elementTouchIsOver.id);

      const elPull = elementTouchIsOver.querySelector('.drag-pull');
      if (elPull && elPull.id) return parseJson(elPull.id);
    }

    const offset = Math.floor((touchY + cTop - sHeight - cHeight - 24) / 24);
    const rangeByHour = rangeByHours[offset];

    if (rangeByHour) return { time: rangeByHour.toISOString(), calculated: true };
  }

  const elMouseOvered = elementFromPoint(mouseX, mouseY);
  if (elMouseOvered) {
    if (elMouseOvered.id) return parseJson(elMouseOvered.id);

    const elPull = elMouseOvered.querySelector('.drag-pull');
    if (elPull && elPull.id) return parseJson(elPull.id);
  }

  const elHoveredOnes = querySelectorAll(':hover');
  if (elHoveredOnes) {
    const elLast = last(elHoveredOnes);
    if (elLast && elLast.id) return parseJson(elLast.id);
  }

  // see if we can find the element that's got the name timestamp
  const elOtherMouseOvered = elementFromPoint(mouseX, mouseY);
  if (elOtherMouseOvered) {
    for (const timestamp of elOtherMouseOvered.childNodes) {
      // eslint-disable-next-line no-continue
      if (!timestamp || !timestamp.id) continue;

      const parsed = parseJson(timestamp.id);
      if (asObject(parsed).time) return parsed;
    }
  }

  const coordinateY = mouseY || touchY || null;
  if (coordinateY) {
    const offset = Math.floor((coordinateY + cTop - sHeight - cHeight - 24) / 24);
    const time = rangeByHours[offset];
    if (time) return { time: time.toISOString(), calcuated: true };
  }

  return {};
});

// noinspection JSUnusedGlobalSymbols
export default determineDropLocation;
